import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import { useNavigate } from "react-router-dom";

export default function InstantModal(props) {
  const navigate = useNavigate();

  async function createOnClick(event) {
    let stream_title = document.getElementById("input-stream-name").value;

    if (stream_title != null && stream_title != "") {
      let user_table = document.getElementById("stream-keywords");
      let keyword_list = user_table.value;

      if (keyword_list != "") {
        console.log(keyword_list)
        navigate("/vault?title=" + stream_title + "&keywords=" + keyword_list);
      } else {
        alert("Please enter your query");
      }
    } else {
      alert("Please enter Topic name");
    }
  }

  return (
    <Modal show={props.showModal} onHide={() => props.setShowModal(false)}>
      {/* Modal for creating new streams */}
      <Modal.Header closeButton>
        <Modal.Title>Understanding Assistant</Modal.Title>
      </Modal.Header>
      <Modal.Body className='stream-modal'>
        <Form.Label className="modal-field" htmlFor="input-stream-name"><h6>Enter Topic name:</h6></Form.Label>
        <Form.Control
          className="modal-field"
          type="text"
          id="input-stream-name"
        />
        <br />
        <h6 className="modal-field">Enter your Query:</h6>

        <div style={{
          marginTop: "10px",
          overflow: "hidden",
          transformOrigin: "top",
          transition: "transform 0.26s ease"
        }}>
          <input id="stream-keywords" placeholder="Automatically generate sub-questions from your open-ended question" className="stream-table-center" style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px", width: "100%" }} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={e => createOnClick(e)} variant="primary">Create</Button>
      </Modal.Footer>
    </Modal>
  );
}